<template>
	<!-- 举报 -->
	<div class="setBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- back -->
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">举报</p>
				</div>
			</div>
		</van-sticky>
		<div class="fkType">
			<h4>《{{bookName}}》<span>{{auther}}</span></h4>
			<!-- <p>第32章 乾坤大挪移</p> -->
			<div class="fkType_btn">
				<button :class="fkType_btnIndex == index ? 'active' : ''" v-for="(item,index) in fkTypeBtnList" :key="index" @click="fkTypeFn(index)">{{item}}</button>
			</div>
		</div>
		<div class="fkTxt">
			<h4>输入举报理由（必填）</h4>
			<div class="textareaBox">
				<textarea class="site" maxlength="100" @input="descInput" v-model="desc"></textarea>
				<span class="xianzhi">{{remnant}}/100</span>
			</div>
		</div>
		<div class="upImgBox">
			<div>
				<van-uploader v-model="fileList" multiple  max-count="2"/>
			</div>
			<!-- <div class="upImg"><img src="../../assets/img/myicon/upimg.png" alt=""></div> -->
		</div>
		<div class="tc_login">
			<img src="../../assets/img/flower.png" alt="">
			<button @click="add_feedback">提交</button>
		</div>
	</div>
</template>


<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				checked: true,
				fkType_btnIndex: 0,
				fkTypeBtnList: ['文章抄袭', '文章刷分', '盗文账号', '投诉及建议','文章涉反涉黑涉黄',],
				desc: '', //文本域内容
				remnant: 0, //开始字数
				fileList:[],
				books_id:'',
				typeVal: 0,//提交类型
				bookName:'',
				auther:'',
			}
		},
		created() {
			this.books_id = this.$route.query.books_id;
			this.bookName = this.$route.query.bookName;
			this.auther = this.$route.query.auther;
		},
		methods: {
			onInput(checked) {
				Dialog.confirm({
					title: '提醒',
					message: '是否切换开关？',
				}).then(() => {
					this.checked = checked;
				});
			},
			fkTypeFn(data) {
				this.fkType_btnIndex = data;
				this.typeVal = data + 1;
			},
			back() {
				this.$router.push('/bookinfo?id=0')
			},
			// 文本域字数限制
			descInput() {
				let txtVal = this.desc.length;
				this.remnant = 0 + txtVal;
			},
			add_feedback(){
				var imgUrlList=[];
				console.log(this.fileList,'fileList');
				this.fileList.forEach((itm,idx) =>{
					imgUrlList.push(itm.content)
				})
				this.$axios.post(this.$api.add_feedback,{
					books_id: this.books_id,
					content: this.desc,
					images: JSON.stringify(imgUrlList),
					type: this.typeVal,
				}).then(res => {
					Toast(res.data.msg)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.setBox {
		background-color: #fff;
		height: 100vh;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4d8a;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 50px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//反馈类型
		.fkType {
			padding: 0 16px;

			h4 {
				line-height: 80px;
				font-size: 30px;
				/*px*/
			}

			p {
				font-weight: 700;
				font-size: 30px;
				/*px*/
				padding-bottom: 30px;
			}


			.fkType_btn {
				button {
					width: calc((100vw - 92px) / 2);
					border: 0;
					margin-right: 30px;
					margin-bottom: 30px;
					border-radius: 5px;
					border: 1px solid #FF4081;
					/*no*/
					background-color: #fff;
					color: #ff4081;
					line-height: 60px;
					font-size: 30px;
					/*px*/
				}

				button.active {
					background-color: #FF4081;
					color: #fff;
				}

				button:nth-child(2n) {
					margin-right: 0;
				}
			}
		}

		//反馈内容
		.fkTxt {
			padding: 0 16px;
			border-bottom: 1px solid #f0f0f0;/*px*/
			h4 {
				line-height: 80px;
				font-size: 30px;
				/*px*/
				color: #7f7f7f;
				font-weight: 300;
			}

			.textareaBox {
				position: relative;
				padding-bottom: 30px;

				textarea {
					padding-top: 10px;
					width: calc(100vw - 32px);
					border: 0;
					height: 150px;
					color: #3d3d3d;
					text-indent: 1em;

					&::placeholder {
						font-size: 24px;
						/*px*/
					}
				}

				.xianzhi {
					position: absolute;
					bottom: 20px;
					right: 0px;
					color: #b2b2b2;
					background-color: #fff;
					font-size: 26px;
					/*px*/
				}
			}
		}

		//上传图片
		.upImgBox {
			position: relative;
			height: 140px;
			margin: 0 16px;
			padding: 30px 0;
			.upImg {
				/deep/.van-uploader{
					/deep/.van-uploader__upload{
						background: url(../../assets/img/myicon/upimg.png) no-repeat;
						/deep/.van-icon{
							&::before{
								display: none !important;
							}
						}
					}
				}
				img {
					position: absolute;
					left: 16px;
					top: 50%;
					transform: translateY(-50%);
					width: 100px;
				}
			}
		}

		.lxfs_box {
			padding: 0 16px;
			padding-top: 20px;

			p {
				color: #a3a3a3;
			}

			.lxfs_val {
				input {
					width: 100%;
					line-height: 60px;
				}

				input::placeholder {
					color: #a3a3a3;
				}
			}
		}

		//denglu
		.tc_login {
			text-align: center;
			margin: 200px 0;
			position: relative;

			img {
				position: absolute;
				top: -110px;
				right: 15%;
				width: 140px;
			}

			button {
				width: 90%;
				background-color: #ff4081;
				color: #fff;
				border: 0;
				line-height: 80px;
				border-radius: 10px;
				font-size: 32px;
				/*px*/
			}
		}
	}
</style>
